import React from 'react';
import ReactDOM from 'react-dom/client';
import { useMagicLinkFromUrl, consumeKycLanding } from './auth.js';
import { LangProvider } from './i18n.js';
import './styles/tokens.css';
import './styles/app.css';
import './styles/login.css';
import App from './prototype/app.jsx';

// Consume ?t=<token> if present, then strip it from the URL.
useMagicLinkFromUrl();
// Consume &kyc=1 (KYC-submission links) so the supplier lands on Documents.
consumeKycLanding();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <LangProvider>
      <App />
    </LangProvider>
  </React.StrictMode>,
);
